(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["val-pack-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    function findForm(root) {
      var scope = root.closest('.shopify-section') || document;
      return (
        scope.querySelector('form[data-type="add-to-cart-form"]') ||
        scope.querySelector('form.shopify-product-form') ||
        document.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    function ownInput(form, name) {
      var el = form.querySelector('input[data-val-field="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        el.setAttribute('data-val-field', name);
        form.appendChild(el);
      }
      return el;
    }

    function apply(root) {
      if (!root) return;
      root.querySelectorAll('.val-pack').forEach(function (el) {
        el.classList.toggle('is-selected', !!el.querySelector('input:checked'));
      });
      root.querySelectorAll('.val-purchase__opt').forEach(function (el) {
        el.classList.toggle('is-selected', !!el.querySelector('input:checked'));
      });

      var form = findForm(root);
      if (!form) return;

      /* quantity */
      var pack = root.querySelector('.val-pack__input:checked');
      var qty = pack ? pack.getAttribute('data-qty') : '1';
      var native = form.querySelector('input[name="quantity"]:not([data-val-field])');
      if (native) {
        if (native.value !== qty) {
          native.value = qty;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        ownInput(form, 'quantity').value = qty;
      }

      /* selling plan */
      var planEl = root.querySelector('.val-purchase__input:checked');
      var plan = planEl ? planEl.value : '';
      var mine = ownInput(form, 'selling_plan');
      mine.value = plan;
      mine.disabled = plan === '';
      form.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (el !== mine) {
          el.disabled = true;
          if (el.checked) el.checked = false;
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.val-packs').forEach(apply);
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.matches('.val-pack__input, .val-purchase__input')) return;
      apply(t.closest('.val-packs'));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    window.addEventListener('load', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
